// @flow
import styled from 'styled-components'
import { Layout, Card } from 'antd'
const { Content } = Layout

export const StyledContent = styled(Content)`
  background: #fff;
  margin: 24px 16px;
  min-height: 280px;
  padding: 0;
  
  .trade-box {
  
  }
`

export const TradeBoxDiv = styled.div`
    padding: 10px;
    margin: 10px;
    border: solid 1px #eee;
    position: relative;
    
    h3 {
      font-size: 15px;
      color: #949392;
      font-weight: bold;
    }
    
    b {
      color: #2b4c6b;
      font-size: 24px;
    }
    span {
      margin-left: 10px;
      border: solid 1px #eee;
      padding: 3px 9px;
      color: #2b4c6b;
      border-radius: 4px;
      white-space: nowrap;
    }
    
    .red {
       background: #f97777;
       border-color: #f97777;
       color: #fff;
       white-space: nowrap;
    }
    
    .green {
       background: #6cb36c;
       border-color: #6cb36c;
       color: #fff;
       white-space: nowrap;
    }
    small {
      color: #2b4c6b;
      position: absolute;
      right: 8px;
      top: 6px;
      font-size: 14px;
      white-space: nowrap;
    }
`

export const StyledCard = styled(Card) `
  width:100%
  .ant-card-head-title {
    p {
      margin: 0;
      span {
        font-size: 10px;
        float: right;
      }
    }
   }
   .ant-card-body {
    padding: 24px 0;
   }
`


// WEBPACK FOOTER //
// ./src/components/ChartDashboard/style.js